import React, { useMemo } from 'react';

import { ThemeProvider } from '@change/ds-core-ui';

import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { ContributeSection } from './components/ContributeSection';
import { HeroSectionMarquee } from './components/HeroSectionMarquee';
import { HeroSectionV3 } from './components/HeroSectionV3';
import { HowToSection } from './components/HowToSection';
import { HowToSectionV3 } from './components/HowToSectionV3';
import { LocalSection } from './components/LocalSection';
import { LocalSectionOld } from './components/LocalSectionOld';
import { ContributeSectionSunrise } from './components/SunriseComponents/ContributeSectionSunrise';
import { HeroSectionSunrise } from './components/SunriseComponents/HeroSectionSunrise';
import { HowToSectionSunrise } from './components/SunriseComponents/HowToSectionSunrise';
import { LocalSectionSunrise } from './components/SunriseComponents/LocalSectionSunrise';
import { TrendingSectionSunrise } from './components/SunriseComponents/TrendingSectionSunrise';
import { TrendingSection } from './components/TrendingSection';
import { usePageBody } from './hooks/usePageBody';

export function PageBody(): React.JSX.Element {
	const {
		data: { showV3, showHowToV3, showSunrise },
	} = usePageBody();

	const heroComponent = useMemo(() => {
		if (showSunrise) return <HeroSectionSunrise />;
		if (showV3) return <HeroSectionV3 />;
		return <HeroSectionMarquee />;
	}, [showV3, showSunrise]);

	const howToSection = useMemo(() => {
		if (!showHowToV3) return null;
		if (showSunrise) return <HowToSectionSunrise />;
		return <HowToSectionV3 />;
	}, [showHowToV3, showSunrise]);

	const localSection = useMemo(() => {
		if (showSunrise) return <LocalSectionSunrise />;
		if (showV3) return <LocalSection />;
		return <LocalSectionOld />;
	}, [showV3, showSunrise]);

	return (
		<ThemeProvider>
			{heroComponent}

			{howToSection}

			<div className="container space-y-16 py-6 md:space-y-28 md:py-[93px]">
				{!showHowToV3 && !showSunrise && <HowToSection />}

				<ClientRender placeholder={<Loader size="m" my={256} mx="auto" />}>{localSection}</ClientRender>

				{showSunrise ? <TrendingSectionSunrise /> : <TrendingSection />}

				{showSunrise ? <ContributeSectionSunrise /> : <ContributeSection />}
			</div>
		</ThemeProvider>
	);
}
